// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AdicionaOrcamentoServicoNoCompromissoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /agenda/adiciona_orcamento_servico_no_compromisso
 *
 * Validates input for adding orcamento services to an existing compromisso.
 */
import type { AgendaAdicionaServicoNestedInput } from './AgendaAdicionaServicoNestedInput'
import { registerContract } from './validate'

export interface Agenda_AdicionaOrcamentoServicoNoCompromissoInput {
compromisso_id: number
servicos?: AgendaAdicionaServicoNestedInput[]
}

registerContract('Agenda_AdicionaOrcamentoServicoNoCompromissoInput', {
  compromisso_id: { type: 'number',  required: true },
  servicos: {
    type: 'array',
    required: false,
    items: {
      orcamento_servico_id:      { type: 'number',  required: true },
      compromisso_servico_valor: { type: 'number',  required: true },
    },
  },
})
